export const clientId = "94275168644-9ep573d6qgv2d71ulonj4ouam0nl8n0q.apps.googleusercontent.com";
// export const GoogleMapsKey = "AIzaSyCK7mxtbLJ5srlppcBbw-bTcKpDRfE_wHg";
// export const GoogleMapsKey = "AIzaSyBtdkwTfOekRQ3oF0LyZmfaKxXwMFpDJEU";

export const GoogleMapsKey = "AIzaSyAsTaFQySIIYHpfICQZMae_lNyNJY7EAcY";
